import { domainLocales } from '@hhgtech/hhg-components/constants'
import { LocaleType } from '@hhgtech/hhg-components/types'
import Cookies from 'js-cookie'

import { callApiNew } from 'api/axios'
import { PATHS } from 'api/paths'
import { callApi } from 'api/utils'
import { getEcommerceApiPath } from 'api/utils/paths'
import { ENV, GUEST_CART_ID_COOKIE } from 'interfaces/constants'

export const GuestCartManager = {
  getCartId: async () => {
    let cartId = Cookies.get(GUEST_CART_ID_COOKIE) || ''
    if (cartId) return cartId
    const res = await callApi(
      getEcommerceApiPath(PATHS.ECOMMERCE.GUEST_GET_CART_ID),
      'POST',
    )
    cartId = res?.data || ''
    Cookies.set(GUEST_CART_ID_COOKIE, cartId, {
      domain:
        ENV.NEXT_PUBLIC_DEPLOY_ENV === 'development'
          ? 'localhost'
          : `.${domainLocales[ENV.DEPLOY_LOCALE as LocaleType]}`,
    })
    return cartId
  },
  addToCart: async (sku: string, quantity: number) => {
    if (!sku || !quantity) return
    const cartId = await GuestCartManager.getCartId()
    if (!cartId) return
    return await callApi(
      getEcommerceApiPath(PATHS.ECOMMERCE.GUEST_ADD_ITEM_TO_CART, { cartId }),
      'POST',
      {
        data: {
          cartItem: {
            sku: sku,
            qty: quantity,
          },
        },
      },
    )
  },
  getCart: async (): Promise<any> => {
    const cartId = await GuestCartManager.getCartId()
    if (!cartId) return
    const res = await callApiNew(
      PATHS.ECOMMERCE.GUEST_GET_CART,
      {
        method: 'GET',
        params: {
          cartId,
        },
      },
      'ecommerce',
    )
    // if (retryCount < 2 && res?.status !== 1) {
    //   cookieHandler.removeCookie(GUEST_CART_ID_COOKIE)
    //   return GuestCartManager.getCart(retryCount + 1)
    // }
    return res
  },
  getCartTotals: async () => {
    const cartId = await GuestCartManager.getCartId()
    if (!cartId) return
    return await callApiNew(
      PATHS.ECOMMERCE.GUEST_GET_CART_TOTALS,
      {
        method: 'GET',
        params: {
          cartId,
        },
      },
      'ecommerce',
    )
  },
}
// === CUSTOMER CART MANAGER ===
export const CustomerCartManager = {
  getCartId: () =>
    callApiNew(
      PATHS.ECOMMERCE.GET_CART_ID,
      {
        method: 'POST',
      },
      'ecommerce',
    ),
  addToCart: (sku: string, quantity: number) => {
    if (!sku || !quantity) return
    return callApiNew(
      PATHS.ECOMMERCE.ADD_ITEM_TO_CART,
      {
        method: 'POST',
        data: {
          cartItem: {
            sku: sku,
            qty: quantity,
          },
        },
      },
      'ecommerce',
    )
  },
  getCart: async (): // cookie?: string,
  // noRetry?: boolean,
  Promise<any> => {
    const res = await callApiNew(
      PATHS.ECOMMERCE.GET_CART,
      {
        method: 'GET',
      },
      'ecommerce',
    )
    return res
  },
  getCartTotals: async () => {
    return callApiNew(
      PATHS.ECOMMERCE.GET_CART_TOTALS,
      {
        method: 'POST',
      },
      'ecommerce',
    )
  },
}
